import { Component, Input, OnInit } from "@angular/core";
import {
  IApiUserCalendarFilter,
} from "src/app/shared/modules/graphql/types/types";
import { DistanceSelectionPayload } from "./calendar-filters/calendar-user-distance-filter/calendar-user-distance-filter.component";

@Component({
  selector: "app-calendar",
  templateUrl: "./calendar.component.html",
  styleUrls: ["./calendar.component.scss"],
})
export class CalendarComponent {
  constructor() { }

  @Input() public filters: IApiUserCalendarFilter[] = [];
  @Input() public userIds: string[] = [];
  @Input() public showFilters: boolean = true;
  @Input() public showTitle: boolean = true;
  @Input() public distanceSelection: DistanceSelectionPayload = {
    userIds: [],
    metrics: [],
  };
  public calendarLoading = false;

  public onApplyFilter(filters: IApiUserCalendarFilter[]): void {
    this.filters = filters;
  }

  public onClearFilter(): void {
    this.filters = [];
    this.userIds = [];
    this.distanceSelection = {
      userIds: [],
      metrics: [],
    };
  }

  public onDistanceSelectionChange(payload: DistanceSelectionPayload): void {
    this.distanceSelection = payload || { userIds: [], metrics: [] };
  }
}
